import React, { useState, ReactNode, ReactElement } from "react";
import { FontStyles } from "../../utils/font-styles.ts";

interface TabProps extends React.PropsWithChildren {
  labels: ReactElement[] | string[];
  onTabChange?: (activeTab: number) => void;
  initialTab?: number;
}

const baseStyle = "font-semibold py-3 w-1/2 !leading-none " + FontStyles["body-md"];
const activeStyle = "text-slate border-b-2 border-north-sea";
const inactiveStyle = "text-neutral-200 border-b-2 border-neutral-200";
const contentStyle = "text-light-slate " + FontStyles["body-l"];

export const Tabs: React.FC<TabProps> = ({ labels, children, onTabChange, initialTab }) => {
  const tabIndex = initialTab ?? 0;
  const [activeTab, setActiveTab] = useState(tabIndex);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
    if (onTabChange) {
      onTabChange(index); // Call onTabChange with the label index of the active tab
    }
  };

  return (
    <div className="flex flex-col w-full">
      <div className="w-full flex">
        {labels.map((label, index) => {
          const isActive = index === activeTab;
          const tabStyle = `${baseStyle} ${isActive ? activeStyle : inactiveStyle}`;

          return (
            <button key={index} onClick={() => handleTabClick(index)} className={tabStyle}>
              {label}
            </button>
          );
        })}
      </div>
      <div className={contentStyle}>{children && (children as ReactNode[])[activeTab]}</div>
    </div>
  );
};
